import { IssueCaseCategory, IssueCaseSubcategory, OrderProduct } from '@gooduncles/gu-app-schema';
import { create } from 'zustand';

import { OrderWithStore } from 'src/utils/order-util';

export type ProductWithOrder = OrderProduct & { order: OrderWithStore };

export interface BulkSoldOutIssueModalState {
  open: boolean;
  products: ProductWithOrder[];
  source: string | null;
}

interface BulkSoldOutIssueModalStore {
  state: BulkSoldOutIssueModalState;
  open: (params: Omit<BulkSoldOutIssueModalState, 'open'>) => void;
  close: () => void;
}

const initialState: BulkSoldOutIssueModalState = {
  open: false,
  products: [],
  source: null,
};

export interface BulkSoldOutIssueInput {
  category: IssueCaseCategory;
  subcategory: IssueCaseSubcategory | null;
  memo: string;
  sendKakao: boolean;
}

export const useBulkSoldOutIssueModal = create<BulkSoldOutIssueModalStore>((set) => ({
  state: initialState,
  open: (params) => set({ state: { open: true, ...params } }),
  close: () => set({ state: initialState }),
}));
